import { SET_SOURCES_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCES_SETTINGS, {
  searchFilter: 'View All',
  searchTerm: ''
})
